import React from "react";

/**
 * boatrvmoving mark — a red slab with a stylised truck+trailer silhouette
 * cut out of it. Kept minimal so it renders crisply at favicon sizes.
 */
export function LogoMark({ size = 40, className = "" }) {
  return (
    <svg
      viewBox="0 0 40 40"
      width={size}
      height={size}
      className={className}
      aria-hidden="true"
    >
      <rect width="40" height="40" fill="#FF3B30" />
      {/* trailer + boat body */}
      <path
        d="M4 26h10l2-6h6l3 6h9v3H4v-3z"
        fill="#0A0A0A"
      />
      {/* cab */}
      <path d="M25 20h5l3 3v3h-8v-6z" fill="#0A0A0A" />
      {/* wheels */}
      <circle cx="12" cy="30" r="2.6" fill="#FF3B30" stroke="#0A0A0A" strokeWidth="1.4" />
      <circle cx="28" cy="30" r="2.6" fill="#FF3B30" stroke="#0A0A0A" strokeWidth="1.4" />
      {/* hitch line */}
      <path d="M14 26l2-4" stroke="#0A0A0A" strokeWidth="1.2" fill="none" />
    </svg>
  );
}

export function Wordmark({ className = "" }) {
  return (
    <span className={`font-display font-black uppercase tracking-tight ${className}`}>
      boat<span className="text-[#FF3B30]">rv</span>moving
    </span>
  );
}
